import { Button as MuiButton, Dialog, DialogContent, DialogTitle, type Theme, Typography, styled } from "@mui/material";

export const ModalDialog = styled(Dialog)(({ theme }: { theme: Theme }) => ({
  "& .MuiDialogContent-root": {
    paddingTop: "16px",
    [theme.breakpoints.between("xs", "sm")]: {
      padding: "24px",
      flex: "unset",
    },
  },
  "& > div > .MuiPaper-root": {
    backgroundColor: "rgba(70,70,70) !important",
    padding: "16px",
    borderRadius: "20px",
    gap: "16px",
    [theme.breakpoints.between("xs", "sm")]: {
      height: "100%",
      width: "100%",
      margin: 0,
      gap: 0,
      padding: 0,
      maxHeight: "unset",
    },
  },
  "& .MuiDialogActions-root": {
    margin: "0 auto",
    padding: "16px",
    justifyContent: "center",
    width: "100%",
    [theme.breakpoints.between("xs", "sm")]: {
      alignItems: "unset",
      flex: "1 1 auto",
      "& button": {
        height: "40px",
      },
    },
    backgroundColor: "#000",
  },
}));

export const ModalTitle = styled(DialogTitle)(({ theme }: { theme: Theme }) => ({
  color: "#fff",
  fontSize: "24px",
  fontWeight: "700",
  backgroundColor: "#000",
  [theme.breakpoints.between("xs", "sm")]: {
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
    padding: "16px",
  },
}));

export const ModalContent = styled(DialogContent)(({ theme }: { theme: Theme }) => ({
  position: "relative",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#000",
  [theme.breakpoints.between("xs", "sm")]: {
    display: "unset",
    height: "unset",
  },
}));

export const AvatarInfo = styled(Typography)({
  color: "#fff",
  marginBottom: "8px",
  fontSize: "16px",
  lineHeight: "24px",
});

export const MessageContent = styled("div")(({ theme }: { theme: Theme }) => ({
  width: "676px",
  height: "336px",
  display: "flex-column",
  justifyContent: "center",
  alignContent: "center",
  [theme.breakpoints.between("xs", "sm")]: {
    width: "100%",
  },
}));

export const Button = styled(MuiButton)<{ $theme: Theme }>(({ $theme }) => ({
  bottom: 0,
  right: 0,
  padding: "8px 12px",
  backgroundColor: $theme.palette.semanticSurface.dark,
  color: "#A2A2A2",
  textAlign: "center",
  width: "100%",
  fontWeight: 500,
  fontSize: "16px",
  borderRadius: 32,
  lineHeight: "24px",
  transition: "background-color 0.3s ease",
  [$theme.breakpoints.between("xs", "sm")]: {
    width: "100%",
  },
  "&:hover": {
    backgroundColor: $theme.palette.semanticNeutral.main,
  },
  "&.submitButton": {
    backgroundColor: "#F50561",
    color: "#fff",
    "&:hover": {
      backgroundColor: $theme.palette.semanticPrimary.main,
    },
  },
  "&.Mui-disabled": {
    color: "#464646 !important",
    background: "#171717 !important",
  },
}));
